import React, { useEffect, useState } from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import Helper from "../../../Helper";
import CommandCenterSplashGCLogo from "../../CommandCenter/CommandCenterSplashGCLogo";

const NoViewSplash: React.FC = () => {
    const context = React.useContext(GlobalStoreContext);
    const [showPlotLogo, setShowPlotLogo] = useState(true);

    useEffect(() => {
        // Simulate loading progress
        const interval = setInterval(() => {
            setShowPlotLogo((prev) => !prev);
        }, 15000);

        return () => clearInterval(interval);
    }, []);
    return (
        <div
            className={Helper.classNames(
                "relative top-0 left-0 right-0 bg-neutral-900 border-b border-neutral-700 z-1100 w-full h-full transition-all duration-700 ease-in-out flex items-center justify-center overflow-hidden"
            )}
        >
            <div style={{ zIndex: -1 }} className="absolute inset-0 flowing-gradient opacity-40" />
            <div className="relative w-1/2 overflow-hidden h-1/2 flex items-center justify-center">
                <img
                    src={"/img/png/logo/plot_jobsite_command.png"}
                    alt="PLOT Logo"
                    className={`absolute object-contain transition-opacity duration-700 ease-in-out w-full h-full opacity-${showPlotLogo ? "75" : "0"} ${showPlotLogo ? "z-10" : "z-0"}`}
                    style={{ opacity: showPlotLogo ? 0.75 : 0, pointerEvents: showPlotLogo ? "auto" : "none" }}
                />
                <div
                    className={`absolute object-contain transition-opacity duration-700 ease-in-out w-full h-full flex items-center justify-center opacity-${showPlotLogo ? "0" : "100"} ${showPlotLogo ? "z-0" : "z-10"}`}
                    style={{ opacity: showPlotLogo ? 0 : 1, pointerEvents: showPlotLogo ? "none" : "auto" }}
                >
                    <div className="relative w-full h-full flex items-center justify-center">
                        <CommandCenterSplashGCLogo team={context.currentTeam} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default NoViewSplash;
